module.exports = __webpack_public_path__ + "static/media/during-booking.dd85eb3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/video-thumbnails/during-booking.png
// module id = 2172
// module chunks = 0